// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__vlWC_","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1mMZs"};